<template>
  <div>
    <Modal v-model="visible" title="导出" width="1000px" class="my-modal">
      <Checkbox :indeterminate="indeterminate" v-model="checkAll" @on-change="handleCheckAll" style="padding-top: 20px">全选</Checkbox>
      <div class="basic-info-box" v-for="(bean, i) in list" :key="i">
        <Checkbox v-model="bean.isCheck" @on-change="selectAll(bean)" style="margin-left: 8px" :true-value="1" :false-value="0">
          <span class="title">{{ bean.menuName }}</span>
        </Checkbox>
        <CheckboxGroup v-model="bean.values" class="check-group" @on-change="selectOne(bean)">
          <Checkbox :label="item.fieldName" class="check" v-for="(item, index) in bean.list" :key="index">
            <span class="label-name">{{ item.name }}</span>
          </Checkbox>
        </CheckboxGroup>
      </div>
      <div class="ivu-modal-footer" slot="footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      visible: false,
      visible1: false,
      indeterminate: false,
      checkAll: false,
      list: []
    };
  },
  computed: {},
  created() {},
  methods: {
    handleCheckAll(val) {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = val;
      }
      this.indeterminate = false;
      if (val) {
        this.list.forEach(item => {
          item.isCheck = 1;
          item.list.forEach(item2 => {
            item2.isCheck = 1;
            if (!item.values.includes(item2.fieldName)) {
              item.values.push(item2.fieldName);
            }
          });
        });
      } else {
        this.list.forEach(item => {
          item.isCheck = 0;
          item.values = [];
          item.list.forEach(item2 => {
            if (item2.isMust == 1 && item2.isExist == 1) {
              item.values.push(item2.fieldName);
              item2.isCheck = 1;
            } else {
              item2.isCheck = 0;
            }
          });
        });
      }
    },
    open(type) {
      this.visible = true;
      this.getConfig(type);
    },
    submit() {
      const list = JSON.parse(JSON.stringify(this.list));
      let values = [];
      list.forEach(item => {
        values = values.concat(item.values);
        delete item.values;
      });
      if (!values.length) {
        this.$notice.error('请至少选择一个字段');
        return;
      }
      this.formData.template = list;
      this.$http({
        url: '/buz/policyExportTemplate/edit',
        type: 'POST',
        data: this.formData
      }).then(res => {
        this.visible = false;
        this.$emit('reload');
      });
    },
    getConfig(val) {
      let url, data;
      if (val) {
        url = '/buz/policyAbnormal/queryExportTemplate';
        data = {};
      } else {
        url = '/buz/policyExportTemplate/queryDeatilByUser';
        data = { type: 1 };
      }
      this.$http({
        url: url,
        type: 'GET',
        data: data
      }).then(res => {
        const list = JSON.parse(res.data.template);
        list.forEach(item => {
          item.values = [];
          item.list.forEach(item2 => {
            if (item.isCheck || item2.isCheck) {
              item.values.push(item2.fieldName);
            }
          });
        });
        this.list = list;
        this.formData = res.data;
        this.checkAll = true;
        this.indeterminate = false;
        this.allData = [];
        this.list.forEach(item => {
          if (item.isCheck) {
            this.indeterminate = true;
          } else {
            this.checkAll = false;
          }
          item.list.forEach(item2 => {
            // 如果父级勾选了,子集也勾选
            if (item.isCheck == 1) {
              item2.isCheck = 1;
            }
            this.allData.push(item2.fieldName);
          });
        });
        console.log(this.list);
      });
    },
    // 全选
    selectAll(item) {
      if (item.isCheck) {
        item.values = [];
        item.list.forEach(item2 => {
          item2.isCheck = 1;
          item.values.push(item2.fieldName);
        });
      } else {
        item.values = [];
        item.list.forEach(item2 => {
          item2.isCheck = 0;
        });
      }
    },
    // 单个选择 检测是否全选
    selectOne(item) {
      const values = [];
      item.list.forEach(item2 => {
        values.push(item2.fieldName);
        if (item.values.includes(item2.fieldName)) {
          // 全选
          item2.isCheck = 1;
        } else {
          item2.isCheck = 0;
        }
      });
      console.log(item.values, values);
      if (item.values.length == values.length) {
        // 全选
        item.isCheck = 1;
      } else {
        item.isCheck = 0;
      }
      let allLength = 0;
      this.list.forEach(item => {
        allLength = allLength + item.values.length;
      });
      if (allLength === this.allData.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (allLength > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal /deep/ {
  .basic-info-box {
    margin-top: 20px;
    .title {
      font-size: 14px;
      color: #515c6f;
      font-weight: bold;
      margin-left: 5px;
      border-bottom: 2px solid #236dff;
    }
    .check-group {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .check {
        margin-top: 10px;
        width: 23.6%;
        span {
          margin-left: 4px;
        }
        & .disabled {
          color: #515c6f;
        }
        .tip-icon {
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #ccc;
          color: #ccc;
          display: inline-block;
          text-align: center;
          line-height: 15px;
          font-size: 12px;
          cursor: pointer;
          top: 50%;
        }
        .label-name {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
